import { render, staticRenderFns } from "./TeamsManagement.vue?vue&type=template&id=4037149c&scoped=true"
import script from "./TeamsManagement.vue?vue&type=script&lang=ts"
export * from "./TeamsManagement.vue?vue&type=script&lang=ts"
import style0 from "./TeamsManagement.vue?vue&type=style&index=0&id=4037149c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4037149c",
  null
  
)

export default component.exports